import { useState, useCallback } from 'react'
import {
  useSensor,
  useSensors,
  MouseSensor,
  TouchSensor,
  DragEndEvent,
  DragStartEvent,
} from '@dnd-kit/core'

interface UseTableDragDropProps {
  handleDrop: (draggedRowId: string, targetRowId: string) => void
}

export function useTableDragDrop({ handleDrop }: UseTableDragDropProps) {
  const [activeId, setActiveId] = useState<string | null>(null)

  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    })
  )

  const handleDragStart = useCallback((event: DragStartEvent) => {
    setActiveId(event.active.id as string)
  }, [])

  const handleDragEnd = useCallback(
    (event: DragEndEvent) => {
      const { active, over } = event
      setActiveId(null)
      if (over && active.id !== over.id) {
        handleDrop(String(active.id), String(over.id))
      }
    },
    [handleDrop]
  )

  const handleDragCancel = useCallback(() => {
    setActiveId(null)
  }, [])

  return {
    activeId,
    sensors,
    handleDragStart,
    handleDragEnd,
    handleDragCancel,
  }
}

